import { useMemo } from 'react';
import { U3202_EMPTY_CAPABILITIES } from '../../u3202AiProvider/utils/U3202CapabilitiesTypes';
import type { U3204MissionRef } from '../U3204Service';
import { u3204ResolveAllowedAttachmentMimeTypes } from '../utils/u3204ResolveAllowedAttachmentMimeTypes';

export { u3204BuildAcceptAttribute } from '../utils/u3204ModelCapabilitiesUtils';

export function useU3204ModelCapabilitiesHandlers(
  activeMission: U3204MissionRef | null,
  initAllowedMimeTypes: string[],
) {
  const defaultModel = activeMission?.defaultModel ?? null;

  const capabilities = useMemo(
    () => defaultModel?.capabilities ?? U3202_EMPTY_CAPABILITIES,
    [defaultModel],
  );

  const allowedMimeTypes = useMemo(
    () =>
      defaultModel
        ? u3204ResolveAllowedAttachmentMimeTypes(capabilities, initAllowedMimeTypes)
        : [],
    [defaultModel, capabilities, initAllowedMimeTypes],
  );

  const canAttachFiles = defaultModel !== null && allowedMimeTypes.length > 0;

  return {
    defaultModel,
    capabilities,
    allowedMimeTypes,
    canAttachFiles,
  };
}
